<template>
  <div class="container1">
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <queryCondition
          ref="queryForm"
          :More="isHaseMore"
          :formConfig="queryCondditionDatas"
          :marginTop="false"
        ></queryCondition>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <div class="main1">
      <div class="left">
        <span>可选择</span>
        <mytable
          :tableHeigth="tableHeigth"
          :tableData="tableDataAlias"
          :myTableHeard="myTableHeard"
          :showFilter="false"
          ref="mytable"
          style="flex: 1; height: calc(100% - 55px)"
          :show-summary = "false"
        ></mytable>
        <paging
          ref="pags"
          :pageNum="pageStart"
          :total="pageCount"
          :size="pageTotal"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
      <div class="mid">
        <el-button size="small" @click="toRight">向右移</el-button>
        <el-button size="small" @click="toLeft">向左移</el-button>
      </div>
      <div class="right">
        <span>已选择</span>
        <mytable
          :tableHeigth="tableHeigth"
          :tableData="selectedRows_1"
          :myTableHeard="myTableHeard"
          :showFilter="false"
          style="flex: 1; height: calc(100% - 55px)"
          :customSelection="true"
          @handleSelectionChange="selectRightData"
        ></mytable>
        <paging
          ref="pags2"
          :pageNum="pageStart1"
          :total="pageCount1"
          :size="pageTotal1"
          @handleSizeChange="handleSizeChange1"
          @handleCurrentChange="handleCurrentChange1"
        ></paging>
      </div>
    </div>
  </div>
</template>

<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/Dialog.vue";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import mytable from "@/components/table/table.vue";
export default {
  mixins: [tableListNew,exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
    mytable,
    myDialog,
    // prints,
  },
  props: {
    data: {},
    financeAssetAccountId:{}
  },
  data() {
    return {
      pageGroupName: "admin_allocation_get_fundflow_list_v5", //  页面标识
      reportFiledsNumber: "admin_allocation_get_fundflow_list_v5", // 动态 条件、表头
      selectedRows: [],
      rightSelectRows: [],
      conditions: {
        exists: this.data,
        financeAssetAccountId:this.financeAssetAccountId
      },
      pageCount: 0,
      pageTotal: 50,
      pageStart: 1,
      selectedRows_1: [],
      pageTotal1: 50,
      pageStart1: 1,
      myTableHeard: [
        {
          name: "流水号",
          field: "financeFundflowNumber",
          isShow: 1,
          width: 120,
        },
        {
          name: "来源类型",
          field: "financeDocumentStatusName",
          isShow: 1,
          width: 120,
        },
        {
          name: "来源单号",
          field: "financeDocumentNumber",
          isShow: 1,
          width: 120,
        },
        {
          name: "收支类型",
          field: "inoutTypeName",
          isShow: 1,
          width: 120,
        },
        {
          name: "资金账号名称",
          field: "fundAccountNumber",
          isShow: 1,
          width: 180,
        },
        {
          name: "金额",
          field: "writeoffAmount",
          isShow: 1,
          width: 120,
        },
        {
          name: "账号余额",
          field: "accountBalance",
          isShow: 1,
          width: 120,
        },
        {
          name: "对账状态",
          field: "reconciliationTypeName",
          isShow: 1,
          width: 120,
        },
        {
          name: "收支备注",
          field: "inoutComment",
          isShow: 1,
          width: 120,
        },
        {
          name: "核销备注",
          field: "writeoffComment",
          isShow: 1,
          width: 120,
        },
        {
          name: "新建时间",
          field: "createTime",
          isShow: 1,
          width: 180,
        },
        {
          name: "操作人",
          field: "createUserName",
          isShow: 1,
          width: 120,
        },
      ],
      params: {},
      inoutTypes: [
        {
          value: 0,
          label: "收入",
        },
        {
          value: 1,
          label: "支出",
        },
      ],
    };
  },
  computed: {
    pageCount1() {
      return this.selectedRows.length;
    },
  },
  methods: {
    selectRightData(e) {
      this.rightSelectRows = e;
    },
    fetched() {
      const ids = this.selectedRows.map((item) => item.id);
      for (let item of this.tableData) {
        if (ids.includes(item.id)) {
          item.selectable = false;
          console.log(item);
        }
      }
      this.tableDataAlias = this.tableData.filter(
        (item) => item.selectable !== false
      );
      this.asyncSelectedRows();
    },
    toRight() {
      const ids = this.selectedRows.map((item) => item.id);
      for (let item of this.selectTableData) {
        if (!ids.includes(item.id)) {
          this.selectedRows.push({
            ...item,
          });
          item.selectable = false;
          this.mytableRefresh(item);
        }
      }
      this.tableDataAlias = this.tableData.filter(
        (item) => item.selectable !== false
      );
      this.asyncSelectedRows();
    },
    toLeft() {
      const rightDatas = this.rightSelectRows;
      const waybillIds = this.tableData.map((item) => item.id);
      const ids = this.selectedRows.map((item) => item.id);
      for (let item of rightDatas) {
        const pos = ids.indexOf(item.id);
        this.selectedRows.splice(pos, 1);
        const pos1 = waybillIds.indexOf(item.id);
        this.tableData[pos1].selectable = true;
        this.mytableRefresh(this.tableData[pos1]);
      }
      this.tableDataAlias = this.tableData.filter(
        (item) => item.selectable !== false
      );
      this.asyncSelectedRows();
    },
    mytableRefresh(row) {
      this.$refs.mytable.resetCheckbox(row);
    },
    getRows() {
      return this.selectedRows;
    },
    asyncSelectedRows() {
      this.selectedRows_1 = this.selectedRows.slice(
        (this.pageStart1 - 1) * this.pageTotal1,
        this.pageStart1 * this.pageTotal1
      );
    },
    handleSizeChange1(size) {
      this.pageTotal1 = size;
      this.asyncSelectedRows();
    },
    handleCurrentChange1(current) {
      this.pageStart1 = current;
      this.asyncSelectedRows();
    },
  },
};
</script>

<style scoped lang="less">
.container1 {
  display: flex;
  flex-flow: column;
  height: calc(100vh - 300px);
  min-height: 200px;
  .glo_btnList {
    align-items: flex-start;
  }
  .glo_btnList_right {
    margin: 0;
    line-height: 34px;
  }
  .main1 {
    display: flex;
    flex: 1;
    overflow: hidden;
    border-top: 1px solid #ebeef5;
    .left {
      flex: 1;
      display: flex;
      flex-flow: column;
      overflow: hidden;
      /deep/ .glo_Table {
        height: 100%;
        overflow: hidden;
        .el-table {
          height: 100% !important;
        }
      }
      .container {
        margin-bottom: -10px;
      }
    }
    .mid {
      width: 80px;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      .el-button {
        margin-left: 0;
      }
    }
    .right {
      flex: 1;
      display: flex;
      flex-flow: column;
      overflow: hidden;
      /deep/ .glo_Table {
        height: 100%;
        overflow: hidden;
        .el-table {
          height: 100% !important;
        }
      }
      .container {
        margin-bottom: -10px;
      }
    }
  }
}
</style>